module.exports = __webpack_public_path__ + "img/hakuna_p02_img01.1e768126.jpg";